export default __webpack_public_path__ + "static/media/BrainBreak cards92.9aa621f8.png";